import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';
import { CommonService } from 'src/app/core/services/common.service';
import { CommonHttpService } from './common-http.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppealService {
private appealCount = new BehaviorSubject<number | null>(null);
appealCount$ = this.appealCount.asObservable();
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private commonService: CommonService,
    private _commonHttpService: CommonHttpService
  ) {}

  fetchAppealList(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchAppealList');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
            this.appealCount.next(this.commonService.decryptUsingAES256(response.body.data).length);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchAppealDocuments(data: any): Observable<any> {
        const url = this.commonService.getFullUrl("fetchDocumentList");
         const rqstBody = {
        responseguid:data,
        isDownload: true
      }
        let encryptedRqstBody = {
          rqstBody: this.commonService.encryptUsingAES256(rqstBody)
        }
       
       
        return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
          .pipe(map((response, error) => {
            if (response) {
              //console.log('file response: ', response);
              return response.body;
            } else {
              return error;
            }
          }));
      }   
  

  fetchAppealCount(){
    return this.appealCount;
  }

  fetchAppealDetail(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchAppealDetail');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchAppealHistoricalDetail(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchAppealHistoricalDetail');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  fetchAppealHistory(data: any): Observable<any> {
    // Encrypt request
    const url = this.commonService.getFullUrl('fetchAppealHistory');
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }


    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
   submitAppeal(payload: any, assessmentStatus?: number | null, mde_appealid?: string | null): Observable<any> {
    const url = this.commonService.getFullUrl('submitAppeal'); // backend route name
    const bodyToEncrypt = {
      payload,
      assessmentStatus: assessmentStatus ?? null,
      mde_appealid: mde_appealid ?? null
    };

    const encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(bodyToEncrypt)
    };

    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
    .pipe(map((response, error) => {
      if (response) {
        //console.log('questionnaireList response: ', response);
        return response.body;
      } else {
        return error;
      }
    }));
  }

  uploadAppealDocuments(
    files: { fileName: string; base64: string }[],
    appealId: string
  ): Observable<any> {
    const url = this.commonService.getFullUrl('uploadDocuments');
  
    const bodyToEncrypt = {
      appealId,
      documents: files
    };
  
    const encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(bodyToEncrypt)
    };
  
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {}).pipe(
      map((response: any) => response?.body),
      catchError((err: any) => {
        console.error('Upload API error:', err);
        return throwError(() => err);
      })
    );
  }


}
